/** Tanggal hari ini menurut waktu Jepang (JST), format YYYY-MM-DD. */
export const jstToday = () =>
  new Date(Date.now() + (9 * 60 + new Date().getTimezoneOffset()) * 60000)
    .toISOString()
    .slice(0, 10);

/** Bulan berjalan menurut waktu Jepang, format YYYY-MM. */
export const jstMonth = () => jstToday().slice(0, 7);
